import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalService } from '../../services';
import { TranslateService } from '@ngx-translate/core';

/**
 * Prawy panel dodawania/edycji numeru alarmowego opaski (alias + numer z prefiksem).
 * Celowo NOWY komponent zamiast przeróbki RightEmergencyPanelComponent — tamten
 * obsługuje osoby do kontaktu (inne pola i inne API) i jest używany w innych widokach.
 * Panel jest czysto prezentacyjny: walidacja i emisja wartości; zapis do backendu
 * robi rodzic (który zna kontekst całego formularza opaski).
 */
@Component({
  selector: 'app-alarm-phone-panel',
  templateUrl: './alarm-phone-panel.component.html',
  styleUrls: ['./alarm-phone-panel.component.scss']
})
export class AlarmPhonePanelComponent implements OnInit {

  /** null = dodawanie nowego numeru; obiekt {alias, numberPrefix, number} = edycja. */
  @Input() phone: any = null;
  @Output() closePanel: EventEmitter<void> = new EventEmitter();
  @Output() phoneSaved: EventEmitter<any> = new EventEmitter();
  @Output() phoneDeleted: EventEmitter<void> = new EventEmitter();

  phoneForm: FormGroup;
  isPanelVisible = false;

  constructor(
    private fb: FormBuilder,
    private modalService: ModalService,
    private translate: TranslateService
  ) {
    // Walidacja numeru jak w telefonach alarmowych configuration-user.
    this.phoneForm = this.fb.group({
      alias: ['', [Validators.maxLength(50)]],
      numberPrefix: [null],
      number: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(15),
        Validators.pattern('^(0|[0-9]*)$')
      ]],
    });
  }

  ngOnInit(): void {
    if (this.phone) {
      this.phoneForm.patchValue({
        alias: this.phone.alias || '',
        numberPrefix: this.phone.numberPrefix || null,
        number: this.phone.number || '',
      });
    }
    setTimeout(() => { this.isPanelVisible = true; }, 50);
  }

  get isEdit(): boolean {
    return this.phone != null;
  }

  close(): void {
    this.isPanelVisible = false;
    setTimeout(() => this.closePanel.emit(), 100);
  }

  save(): void {
    if (this.phoneForm.invalid) {
      this.phoneForm.markAllAsTouched();
      return;
    }
    const v = this.phoneForm.value;
    // repeatNumber = number: backend wymaga potwierdzenia numeru, a UI ma jedno pole.
    this.phoneSaved.emit({
      alias: v.alias || null,
      numberPrefix: v.numberPrefix,
      number: v.number,
      repeatNumber: v.number,
    });
    this.close();
  }

  remove(): void {
    if (!this.isEdit) { return; }
    this.modalService.openAccept(
      this.translate.instant('WIZARD.DELETE-ALARM-PHONE-CONFIRM'),
      'EVENTS.SHARED.COMPONENTS.ALARM-PHONE-PANEL.POPUP.WIZARD-DELETE-ALARM-PHONE-CONFIRM'
    ).subscribe(data => {
      if (data.ok) {
        this.phoneDeleted.emit();
        this.close();
      }
    });
  }
}
